export default __webpack_public_path__ + "static/media/Office.d12bc2f8.png";